import React, { useContext } from 'react'
import styles from './contacts.module.css'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Language from '../components/Language/Language'
import { store } from '../state/state'
import { translate } from '../state/translate'

export default function Contacts() {
  let {selectedLang} = useContext(store)
  return (
    <div className={styles['contacts']} id="contact">
        <div className={styles['logo']}>
          <img src="/logo.webp" alt="" />
        </div>
        <div className={styles['contacts-container']}>
            <h1>{translate[selectedLang].contucts}</h1>
            <div className={styles['contacts-info']}>
                <FontAwesomeIcon icon={faEnvelope} />
                <a href="mailto:info@aks.am">info@aks.am</a>
            </div>
            <div className={styles['contacts-info']}>
                <img src="/instagram.png" alt="Instagram" />
                <a href="https://www.instagram.com/akssoft.am/" target="_blank">Instagram</a>
            </div>
            <Language />
        </div>
    </div>
  )
}
